import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';

import { MaterialCodigoBarra } from "../material-codigo-barra.model";
import { MaterialCodigoBarraService } from "../material-codigo-barra.service";
import { UtilService } from "../../../../../shared/services/util.service";
import { Gtin13Validator } from "../../../../../shared/validators/gtin13.validatior";

declare var swal: any;

@Component({
  selector: 'material-codigo-barra-formulario',
  template: require('./material-codigo-barra-form.component.html')
})

export class MaterialCodigoBarraFormComponent implements OnInit {
  @Input() formObject: any = new MaterialCodigoBarra();
  @Output() submitEvent: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  btnSalveDisabled: boolean = false;
  submitAttempt: boolean = false;

  formMaterialCodigoBarra: FormGroup;
  material: FormControl;
  codigoBarra: FormControl;
  ativo: FormControl;

  private hasSession:boolean = false;

  constructor(
    private _materialCodigoBarraService: MaterialCodigoBarraService,
    private _utilService: UtilService,

    private builder: FormBuilder
  ){
    this.material = new FormControl('', Validators.required);
    this.codigoBarra = new FormControl('', Validators.compose([Validators.required, Gtin13Validator.gtin13Format]));
    this.ativo = new FormControl();
    this.formMaterialCodigoBarra = builder.group({
      ativo: this.ativo,
      material: this.material,
      codigoBarra: this.codigoBarra
    });
  }

  ngOnInit() {
    this.testSession();
    document.getElementById("codigoBarra_codigoBarra").focus();

    if (this.formObject.id) {
      //edicao
      this.getObject();
    }
  }

  onSubmit(evt: any) {
    this.submitAttempt = true;
    if(evt.valid) {
      this.btnSalveDisabled = true;
      var object:any = this._utilService.cloneObject(this.formObject);

      if (object.material) {
        object.materialId = object.material.id;
      }

      if (object.codigoBarra) {
        object.codigoBarra = object.codigoBarra.replace(/\D/g, '');
      }

      delete object['material'];

      if (object.id) {
        this.onEditMaterialCodigoBarra(object);
      } else {
        this.onSaveMaterialCodigoBarra(object);
      }
    }
  }

  private onSaveMaterialCodigoBarra(objeto: any) {
    this._materialCodigoBarraService.onPost(objeto, this.onDone);
  }

  private onEditMaterialCodigoBarra(objeto: any) {
    this._materialCodigoBarraService.onPut(objeto, this.onDone);
  }

  private onDone = (function(Response: any) {
    this.submitEvent.next(Response);
    this.btnSalveDisabled = false;
  }.bind(this));

  onclickCancel() {
    this.cancelEvent.next('');
  }

  private testSession() {
    var session: any = this._materialCodigoBarraService.getSessionStorage();
    if (session) {
      this.formObject = session;
      this.hasSession = true;
    }
  }

  //se edicao
  private getObject() {
    var onDone = (function(Response: any) {
      if (!Response.error) {
        this.formObject = Response;
      } else {
        this._utilService.swalMessageWarningCustom(Response.error);
        this.onclickCancel();
      }
    }.bind(this));

    this._materialCodigoBarraService.onGetById(this.formObject.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/shared/material-codigo-barra-form/material-codigo-barra-form.component.ts
 **/